import React from "react";
import {
  CardContainer,
  IconContainer,
  Link,
  TextContainer,
  ContactContainer,
} from "./styled-components";
import Text from "../text";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";

const ContactCard = ({ text }: { text?: string }) => {
  return (
    <CardContainer>
      <TextContainer>
        <IconContainer>
          <InfoIcon />
        </IconContainer>
        {text ? (
          <Text size="16px">{text}</Text>
        ) : (
          <Text size="16px">
            Vous avez des questions ? Le Défenseur des droits vous écoute et
            vous aide gratuitement partout en France
          </Text>
        )}
      </TextContainer>
      <ContactContainer>
        Appelez le &nbsp;<Link href="tel:0969390000">09 69 39 00 00</Link>
      </ContactContainer>
    </CardContainer>
  );
};

export default ContactCard;
